<!-- path-selector.component.html -->
<p-treeselect
  [options]="treeNodes()"
  [ngModel]="_selectedNodes"
  (onNodeSelect)="onNodeSelectEvent($event)"
  (onNodeUnselect)="onNodeUnselectEvent($event)"
  (onClear)="onClearEvent()"
  selectionMode="checkbox"
  display="chip"
  placeholder="Selecione paths..."
  [filter]="true"
  filterPlaceholder="Buscar path..."
  [showClear]="true"
  [propagateSelectionDown]="false"
  [propagateSelectionUp]="false"
  appendTo="body"
  [style]="{ width: '100%' }" />

<!-- Chips dos paths selecionados com indicador de primário -->
<div class="flex flex-wrap gap-2 mt-2">
  @for (path of selectedPaths(); track path.pathId) {
    <p-chip
      [class.border-primary]="path.isPrimary"
      [styleClass]="path.isPrimary ? 'bg-blue-100 border-blue-500 border-2' : ''">
      <span class="p-chip-icon">
        @if (path.isPrimary) {
          <i class="pi pi-star-fill text-yellow-500 mr-1 cursor-pointer" title="Path Principal"></i>
        } @else {
          <i
            class="pi pi-star cursor-pointer mr-1"
            (click)="setPrimary(path.pathId)"
            title="Tornar Principal"></i>
        }
      </span>
      <span class="p-chip-text">{{ path.fullPath || path.pathId }}</span>
      <span
        tabindex="0"
        class="p-chip-remove-icon pi pi-times-circle"
        (click)="removePath(path.pathId)"></span>
    </p-chip>
  }
</div>
